import { dateOf, esc } from './sbchart.ts';

export function runtimeFailureHTML(seed: number, lastDisplayedDay: number, message: string): string {
  const when = Number.isSafeInteger(lastDisplayedDay) && lastDisplayedDay >= 0 ? dateOf(lastDisplayedDay) : '日期未知';
  return `<b>模拟引擎已停止</b><span>种子 ${esc(seed)} · 最近显示 ${when}。${esc(message.slice(0, 500))}</span>` +
    '<span>已暂停推进，保留当前画面和已生成的下载文件。这不是仍在计算；重新开城会生成新城市。</span>';
}
